// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2_pfp","selected":"Chip_selected__2PF0u"};